<template>
  <div class="form-lower entry thanks">
    <lang />
    <section class="wrapper">
      <div class="form_ttl">
        <h1>
          <router-link :to="{ name: 'Home', params: { lang: $route.params.lang }}">
            <img src="@/assets/img/client/logo.png" alt="GLOCALY">
          </router-link>
        </h1>
      </div>
      <h2>{{ $t('temporary_registration') }}</h2>
      <p class="center" v-html="$t('Membership registration')"></p>
    </section>
  </div>
</template>

<script>
import lang from '@/components/client/language/language'

export default {
  data () {
    return {
      language: this.$route.params.lang
    }
  },
  components: {
    lang
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">

</style>
